/* defaultAnchorImage.tsx */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';
import withImage from '@shared/components/utils/hoc/withImage';

const DefaultAnchorImage = styled.img<React.CSSProperties>`
  height: ${Screen.widthRatio * 100}px;
`;

export default withImage(DefaultAnchorImage);
